export default function({ node, html }) {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')

  const scripts = doc.querySelectorAll('script')
  for (let i = 0; i < scripts.length; i++) {
    const newScript = document.createElement('script')
    if (scripts[i].src) {
      newScript.src = scripts[i].src
    }
    if (scripts[i].innerHTML) {
      newScript.appendChild(document.createTextNode(scripts[i].innerHTML))
    }

    node.appendChild(newScript)
  }
}
